export class ErrorConstants {
    public static TOKEN_INVALID = 10; 
    public static TOKEN_EXPIRED = 11; 
    public static ACCOUNT_LOCKED = 12; 
    public static NEW_PASSWORD_INCORRECT = 13; 
    public static PASSWORD_INCORRECT = 14; 
    public static ACCOUNT_INACTIF = 15; 
    public static USER_NOT_FOUND = 16;
    public static ACCOUNT_ACTIVE = 17;
    public static CODE_INVALIDE = 18;
    public static ACCOUNT_DESACTIVATED = 21;
}